module.exports = __webpack_public_path__ + "files/fd56b032da391481bd89ed81594526ae.svg";